// components/PrivateRoute.jsx
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Preloader from "../../../components/Preloader";

const PrivateRoute = ({ children }) => {
  const { user, token, loading } = useSelector((state) => state?.userAuth || {});
  const location = useLocation();
  const navigate = useNavigate();
  const isNavigatingRef = React.useRef(false);

  useEffect(() => {
    if (isNavigatingRef.current) return;
    
    if (loading) return;
    
    if (!user || !token) {
      isNavigatingRef.current = true;
      navigate("/login", { replace: true, state: { from: location } });
      return () => {
        isNavigatingRef.current = false;
      };
    }
    isNavigatingRef.current = false;
  }, [user, token, loading, location, navigate]);

  const isAuthenticated = Boolean(user && token);

  // An authenticated session must NOT be swapped for a spinner while a
  // background profile refresh is in flight — doing so unmounted pages that
  // dispatch profileInfo() on mount, whose pending state re-mounted them,
  // producing an infinite loader loop (e.g. /profile/manage-account).
  // The loader is only shown during initial bootstrap, while we still don't
  // know whether the visitor is logged in.
  if (!isAuthenticated) {
    if (loading) {
      return <Preloader variant="inline" containerClassName="min-h-[40vh]" />;
    }
    return null;
  }

  return children;
};

export default PrivateRoute;
